var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "hero is-white is-fullheight" }, [
      _c("div", { staticClass: "hero-body" }, [
        _c("div", { staticClass: "container has-text-centered" }, [
          _c("img", {
            staticStyle: { "max-height": "150px" },
            attrs: { src: require("../assets/logo_black.png") }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }